'use client'
import {
  StripeButton,
  StripeForm,
  StripeProvider,
} from '@/core/payment-providers/stripe'
import { useTranslations } from 'next-intl'
import { PaymentStrategy } from './type'

const Fragment: React.FC<{
  children: React.ReactNode
}> = ({ children }) => <>{children}</>

export const useStripeStrategy: PaymentStrategy = ({
  paymentDetails,
  onPaymentSuccess,
  onPaymentFail,
}) => {
  const t = useTranslations()
  if (!paymentDetails?.clientSecret)
    return {
      Button: null,
      Form: null,
      Provider: Fragment,
    }
  return {
    Button: (
      <StripeButton
        className='h-11 w-56 self-end'
        clientSecret={paymentDetails.clientSecret}
        onSuccess={onPaymentSuccess}
        onError={onPaymentFail}
      >
        {t('actions.confirmPayment')}
      </StripeButton>
    ),
    Form: <StripeForm />,
    Provider: StripeProvider,
  }
}
